export default [
    {
        path: '/agent/inventory',
        props: true,
        component: () => import('@/views/Agent/Inventory'),
    },
];